// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 583 ? "chunk-xterm" : chunkId) + "." + {"583":"1a5bee73","902":"7040d18e"}[chunkId] + ".chunk.css";
};